
import { defineComponent } from 'vue';

export default /*#__PURE__*/ defineComponent({
	name: 'HelloWorld',
	props: {
		test: { type: String, default: 'test' }
	},
	setup(props) {
		console.log(props.test);
	}
});
